import React from "react";
import { Avatar, Box, Tooltip, Typography } from "@mui/material";

const ASSIGNED_REP_ROLES = new Set(["order-rep", "client-rep"]);
const DEPOSIT_ASSIGNEE_ROLES = new Set([...ASSIGNED_REP_ROLES, "administrator"]);
const normalizeRole = (value) => String(value || "").trim().toLowerCase().replace(/[_\s]+/g, "-");
const repName = (rep = {}) => [rep.first_name || rep.firstName, rep.last_name || rep.lastName].filter(Boolean).join(" ").trim() || rep.email || "Assigned rep";
const repRole = (rep = {}) => normalizeRole(rep.role).replace(/-/g, " ").replace(/\b\w/g, (letter) => letter.toUpperCase());
export const resolveFinanceAssigneeAvatar = (rep = {}) => {
  const raw = rep.profilePicture || rep.profile_picture || rep.avatarUrl || rep.avatar || rep.photoUrl || null;
  if (Array.isArray(raw)) return resolveFinanceAssigneeAvatar({ profilePicture: raw.find((entry) => entry?.selected || entry?.isSelected) || raw[0] });
  if (typeof raw === "object" && raw !== null) return resolveFinanceAssigneeAvatar({ profilePicture: raw.url || raw.src || raw.path || raw.location });
  if (typeof raw !== "string" || !raw.trim()) return undefined;
  if (/^https?:\/\//i.test(raw)) return raw;
  if (raw.startsWith("/")) return `${process.env.REACT_APP_NODEJS_SERVER_URL}${raw}`;
  if (raw.startsWith("uploads")) return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${raw}`;
  try { return resolveFinanceAssigneeAvatar({ profilePicture: JSON.parse(raw) }); } catch (_) { return raw; }
};

export const getFinanceOrderAssignees = (row = {}, { includeAdministrators = false } = {}) => {
  const allowedRoles = includeAdministrators ? DEPOSIT_ASSIGNEE_ROLES : ASSIGNED_REP_ROLES;
  const embedded = (Array.isArray(row.assignedTo) ? row.assignedTo : [])
    .filter((rep) => allowedRoles.has(normalizeRole(rep?.role)));
  const reportDetails = [row.orderRepDetail, row.clientRepDetail].filter(Boolean);
  const candidates = embedded.length ? embedded : reportDetails;
  return candidates.filter((rep, index) => candidates.findIndex((candidate) => String(candidate.id || candidate.userId || repName(candidate)) === String(rep.id || rep.userId || repName(rep))) === index);
};

export default function FinanceAssigneeAvatars({ row, includeAdministrators = false }) {
  const assignedReps = getFinanceOrderAssignees(row, { includeAdministrators });
  return (
    <Box aria-label="Assigned representatives" sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
      {assignedReps.length ? assignedReps.slice(0, 3).map((rep, index) => (
        <Tooltip key={rep.id || rep.userId || `${repName(rep)}-${index}`} title={`${repName(rep)}${repRole(rep) ? ` · ${repRole(rep)}` : ""}`} arrow>
          <Avatar src={resolveFinanceAssigneeAvatar(rep)} alt={repName(rep)} sx={{ width: 28, height: 28, ml: index ? -0.75 : 0, border: "2px solid #fff", fontSize: 11 }}>{repName(rep).split(/\s+/).map((part) => part[0]).slice(0, 2).join("")}</Avatar>
        </Tooltip>
      )) : <Typography variant="caption" color="text.secondary">Unassigned</Typography>}
    </Box>
  );
}
